import * as T3_Ajax from 'T3_AJAX';
import * as Loader from 'LOADER';

function ready(fn) {
  if (document.readyState != 'loading') {
    fn();
  } else if (document.addEventListener) {
    document.addEventListener('DOMContentLoaded', fn);
  } else {
    document.attachEvent('onreadystatechange', function () {
      if (document.readyState != 'loading') fn();
    });
  }
}

const init = () => {
  if ($('.ce.ce--vd_survey_download').length > 0) {
    let params = {
      action: 'exportData',
      controller: 'Ajax',
      extension: 'tx_vdsurveys',
      typeNum: 787839,
      pid: $('html').attr('data-page-id'),
    };

    let _caller = $('.ce.ce--vd_survey_download');

    T3_Ajax.call(
      params,
      _caller,
      function (params, _caller) {
        let loader = Loader.build({
          message: 'Antworten werden exportiert!',
        });
        $('.ce.ce--vd_survey_download').addClass('status status--loading').append(loader);
      },
      function (params, _caller, data) {
        $('.ce.ce--vd_survey_download')
          .removeClass('status')
          .removeClass('status--loading')
          .html(data.content);
      }
    );
  }
};

const actions = () => {
  /* $(document).on('click', '[data-action]', function (e) {
    e.preventDefault();

    let _self = $(this);

    switch (_self.attr('data-action')) {
      case 'download-pdf':
        result(_self);
        break;

      case 'downloadExport':
        downloadExportAction(_self);
        break;
    }
  }); */
};

const initDownloads = () => {
  ready(function () {
    $('[data-action="download-pdf"]').each(function () {
      let _self = $(this);
      getDownloadLink(_self);
    });
  });
};

const getDownloadLink = (_caller) => {
  let params = {
    action: 'downloadResult',
    controller: 'Ajax',
    extension: 'tx_vdsurveys',
    typeNum: 787839,
    pid: $('html').attr('data-page-id'),
    fileType: _caller.attr('data-source'),
    token: _caller.attr('data-token'),
    async: false,
    project: $('.body__container').hasClass('jrk') ? 'jrk':'drk'
  };

  T3_Ajax.call(
    params,
    _caller,
    function (params, _caller) {
      //alert('start download');
    },
    function (params, _caller, data) {
      if (data.success) {
        _caller.attr('href', '/' + data.pathFileName);
        _caller.attr('target', '_blank');
      }
    }
  );
};

const downloadExportAction = (_caller) => {
  let params = {
    action: 'downloadExport',
    controller: 'Ajax',
    extension: 'tx_vdsurveys',
    typeNum: 787839,
    pid: $('html').attr('data-page-id'),
    filename: _caller.attr('data-filename'),
    filePathName: _caller.attr('data-file-path-name'),
    dataType: 'text/csv',
  };

  T3_Ajax.callDownload(
    params,
    _caller,
    function (params, _caller) {
      _caller.addClass('status status--loading');
    },
    function (params, _caller, data) {
      _caller.removeClass('status--loading');
      window.location = params.url;
    }
  );
};

const result = (_caller) => {
  let params = {
    action: 'downloadResult',
    controller: 'Ajax',
    extension: 'tx_vdsurveys',
    typeNum: 787839,
    pid: $('html').attr('data-page-id'),
    fileType: _caller.attr('data-source'),
    token: _caller.attr('data-token'),
    async: false,
  };

  T3_Ajax.call(
    params,
    _caller,
    function (params, _caller) {
      //alert('start download');
    },
    function (params, _caller, data) {
      if (data.success) {
        window.open(window.location.origin + '/' + data.pathFileName, '_blank');
        //window.location = window.location.origin + '/' + data.pathFileName;
      }
    }
  );
};

/**
 * export methods
 */

export { actions, init, initDownloads };
